import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Circles } from "react-loader-spinner"; // import spinner
const apiUrl = process.env.REACT_APP_API_URL;
function ProtectedRoute({ children, requiredRoles, area }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    useEffect(() => {
        const url =
            area === "AdminArea"
                ? `${apiUrl}/api/auth/admin/me`
                : `${apiUrl}/api/auth/user/me`;

        axios
            .get(url, { withCredentials: true })
            .then((res) => {
                setUser(res.data);
            })
            .catch(() => {
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <div style={{
                height: '100vh'
            }} className="d-flex justify-content-center align-items-center flex-column">
                <Circles
                    height="40"
                    width="40"
                    color="#54b4d3"
                    ariaLabel="circles-loading"
                />
                <div className="text-center">
                    <p className="fs-9 mt-3 mb-0">Verifying user…</p>
                    <p className="fs-9 mt-1">Please wait a moment</p>
                </div>
            </div>
        );
    }

    if (!user) {
        const redirectUrl = encodeURIComponent(location.pathname + location.search);
        if(area === "AdminArea") return <Navigate to={`/auth/admin-signin?redirect=${redirectUrl}`} replace />;
        return <Navigate to={`/auth/signin?redirect=${redirectUrl}`} replace />;
    }

    if(area === "AdminArea" && user.Area === "UserArea"){
        return <Navigate to="/ai-chatbot" replace />;
    }

    return children;
}

export default ProtectedRoute;
